<template>
  <AppLayout>
    <transition :name="navTransition">
      <MainNav v-if="isNavVisible && !isViewingEstateDetails" />
    </transition>
    <div
      id="app-container"
      :style="style"
      :data-e2e="AppCypressAttribute.views.OPS_LAYOUT_APP_CONTAINER"
    >
      <AppBanner />
      <router-view :key="$route.query?.refresh" />
      <SpotlightSearch />
    </div>
  </AppLayout>
</template>

<script>
import MainNav from '/@/modules/core/nav/components/MainNav.vue';
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';
import { PredefinedService } from '/@/modules/predefined/services/PredefinedService';
import { getters } from '/@/modules/core/app/helpers/store';
import AppBanner from '@/modules/core/app/components/AppBanner.vue';
import SpotlightSearch from '@/modules/spotlight/components/stateful/SpotlightSearch.vue';
import { DetectAuthSessionMismatchMixin } from '@/modules/auth/mixins/DetectAuthSessionMismatchMixin';
import AppLayout from '@/modules/core/app/components/presentational/AppLayout.vue';
import { NavToggleMixin } from '@/modules/core/nav/mixins/NavToggleMixin';
import { AppCypressAttribute } from '@/modules/core/app/constants/AppCypressAttribute';
import { NavTransitionType } from '@/modules/core/nav/constants/NavTransitionType';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'OpsLayout',
  mixins: [DetectAuthSessionMismatchMixin, NavToggleMixin],
  components: {
    AppLayout,
    AppBanner,
    MainNav,
    SpotlightSearch
  },
  static: {
    AppCypressAttribute
  },
  async beforeRouteEnter(to, from, next) {
    await PredefinedService.onInit();
    DocumentUIService.removeAppLoader();
    next();
  },
  computed: {
    isViewingEstateDetails() {
      return getters.auth.getUser()?.isViewingEstateDetails;
    },
    navTransition() {
      return this.isViewingEstateDetails ? NavTransitionType.SLIDE : NavTransitionType.NONE;
    }
  }
};
</script>
